// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__2cc20","icon":"Alert_icon__2Mf40","content":"Alert_content__1Fmyl","code":"Alert_code__Dxmrb","gift":"Alert_gift__3TvF5"};